import { Link } from 'react-router-dom';
import { Settings, CreditCard, Globe, MapPin, Activity, FileEdit, Image, TrendingUp, Eye } from 'lucide-react';

const cards = [
  { label: 'API Config', icon: Settings, href: '/admin/api-config', desc: 'Google, Bing, Maps APIs' },
  { label: 'Payments', icon: CreditCard, href: '/admin/payments', desc: 'Stripe, PayPal, Square' },
  { label: 'Web App', icon: Globe, href: '/admin/webapp', desc: 'GAS deployment settings' },
  { label: 'Addresses', icon: MapPin, href: '/admin/addresses', desc: 'UK, IE, EMEA offices' },
  { label: 'Diagnostics', icon: Activity, href: '/admin/diagnostics', desc: 'Health check tools' },
  { label: 'Page Editor', icon: FileEdit, href: '/admin/page-editor', desc: 'Edit page content' },
  { label: 'Content & SEO', icon: Image, href: '/admin/content-seo', desc: 'Images and SEO per page' },
];

const stats = [
  { label: 'Total Pages', value: '8', icon: FileEdit, change: '+2 this month' },
  { label: 'API Keys Set', value: '3/6', icon: Settings, change: '50% configured' },
  { label: 'Active Addresses', value: '3', icon: MapPin, change: 'UK, IE, EMEA' },
  { label: 'Site Views', value: '1,247', icon: Eye, change: '+12% this week' },
];

export default function Dashboard() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-heading text-2xl font-bold text-white">Dashboard</h1>
        <p className="text-white/60 text-sm mt-1">Overview of your site configuration and tools.</p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((stat) => (
          <div key={stat.label} className="card-dark p-5">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-white/70 text-xs uppercase tracking-wider">{stat.label}</p>
                <p className="font-heading text-2xl font-bold text-white mt-1">{stat.value}</p>
              </div>
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#FFDD00]/20 text-[#0057B7]">
                <stat.icon className="w-4.5 h-4.5" />
              </div>
            </div>
            <p className="text-xs text-white/60 mt-3 flex items-center gap-1">
              <TrendingUp className="w-3 h-3 text-[#22c55e]" />
              {stat.change}
            </p>
          </div>
        ))}
      </div>

      {/* Quick Access Grid */}
      <div>
        <h2 className="font-heading font-semibold text-white mb-4">Quick Access</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {cards.map((card) => (
            <Link
              key={card.href}
              to={card.href}
              className="card-dark p-5 hover:border-[#FFDD00]/30 transition-colors group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#FFDD00]/10 text-[#0057B7] mb-3 group-hover:bg-[#FFDD00]/20 transition-colors">
                <card.icon className="w-5 h-5" />
              </div>
              <h3 className="font-heading font-semibold text-white text-sm">{card.label}</h3>
              <p className="text-xs text-white/70 mt-1">{card.desc}</p>
            </Link>
          ))}
        </div>
      </div>

      {/* Recent Activity */}
      <div className="card-dark p-6">
        <h2 className="font-heading font-semibold text-white mb-4">Recent Activity</h2>
        <div className="space-y-3">
          {[
            { action: 'Site config updated', time: '2 hours ago', icon: Settings },
            { action: 'UK address modified', time: '5 hours ago', icon: MapPin },
            { action: 'Diagnostics run completed', time: '1 day ago', icon: Activity },
            { action: 'Home page SEO updated', time: '2 days ago', icon: Image },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-3 py-2 border-b border-white/5 last:border-0">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/5 text-white/60">
                <item.icon className="w-4 h-4" />
              </div>
              <div className="flex-1">
                <p className="text-sm text-white/80">{item.action}</p>
                <p className="text-xs text-white/60">{item.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}